import { DialerSip } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";

export default function ConfirmationDialog({
  open,
  title,
  message,
  onConfirm,
  onCancel,
}) {
  return (
    <Dialog maxWidth="sm" fullWidth open={open} onClose={onCancel}>
      <DialogTitle>
        <Typography variant="h5">{title}</Typography>
        <Divider sx={{ my: 2 }} />
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="subtitle1">{message}</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="outlined" color="error">
          Откажи
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          autoFocus
        >
          Потврди
        </Button>
      </DialogActions>
    </Dialog>
  );
}
